export default [
    {
        image: require('../images/1.png'),
        title: '影视娱乐',
        subtitle: '你可以在APP内了解最新的明星、综艺、电影、电视、音乐动态'
    },
    {
        image: require('../images/2.png'),
        title: '追星神器',
        subtitle: '找到你喜欢的明星，关注TA最新动态，参与TA有趣的话题讨论'
    },
    {
        image: require('../images/3.png'),
        title: '福利放送',
        subtitle: '明星专辑、签名照、电影票、演唱会门票，明星周边等免费领取'
    }
]
